<template>
    <div :class="inline != undefined ? 'd-flex flex-wrap' : ''">
        <v-chip v-if="rollup_status === 'ready'" :class="inline != undefined ? 'mt-1 mr-1' : ''"
            variant="flat" size="x-small" color="success">
            {{ t("ready") }}
        </v-chip>
        <template v-else>
            <template v-for="(s, i) in visible_stations" :key="s.name">
                <v-tooltip location="top" :text="tooltip_for(s)">
                    <template #activator="{ props }">
                        <v-chip v-bind="props"
                            :class="i === 0 ? 'mt-1' : 'ml-1 mt-1'"
                            size="x-small"
                            :variant="chip_for(s).outlined ? 'outlined' : 'flat'"
                            :color="chip_for(s).color">
                            <span class="pit-mono">{{ s.ready }}/{{ s.total }}</span>
                        </v-chip>
                    </template>
                </v-tooltip>
            </template>
        </template>
    </div>
</template>

<script>
import { useFullPitStore } from "@/stores/app_common";
import { aggregateGroupStatus } from "@/utils/multipanel_status";

export default {
    setup() {
        return { ...useFullPitStore() }
    },
    props: ["group", "inline"],
    computed: {
        batch() {
            return this.constructibles_store.batchesByUuid.get(this.group?.batch)
        },
        pl_stations() {
            return this.factories_store.getPLStations(this.batch?.production_line)
        },
        assembliesByUuid() {
            const map = new Map()
            for (const a of this.constructibles_store.assemblies || []) map.set(a.uuid, a)
            return map
        },
        aggregated() {
            return aggregateGroupStatus(this.group, this.assembliesByUuid, this.pl_stations)
        },
        rollup_status() {
            return this.aggregated.status
        },
        visible_stations() {
            return this.aggregated.stations.filter(s => s.total > 0)
        },
    },
    methods: {
        chip_for(s) {
            if (s.rollup === "ready") return { color: "success", outlined: false }
            if (s.rollup === "working") return { color: "warning", outlined: false }
            return { color: "info", outlined: true }
        },
        tooltip_for(s) {
            return `${s.name} — ${s.ready} ready · ${s.working} working · ${s.waiting} waiting`
        },
    },
}
</script>
